import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=12e6d720&scoped=true"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&id=12e6d720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6d720",
  null
  
)

export default component.exports